import { convertsCentsToCurrency, DEFAULT_LOCALE } from '@npi/buddy-utils';
import LocaleToCurrency from 'locale-currency';

const formatCentsToLocaleCurrency = (cents: number, _localeLanguage: string) => {
    // (KM) Hard-coding for now until we find a solution to get the user's currency
    const locale = DEFAULT_LOCALE;
    const currencyAmount = convertsCentsToCurrency(cents);
    const localeCurrency = LocaleToCurrency.getCurrency(locale);

    if (!localeCurrency) {
        throw new TypeError('Locale currency not found');
    }

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: localeCurrency,
    }).format(currencyAmount);
};

export default formatCentsToLocaleCurrency;
